module.exports = __webpack_public_path__ + "img/patient-landing-chart.178bd2fa.svg";